import { useTranslation } from "react-i18next";
import ZoomControls from "../../../components/restaurant-schema/ZoomControls";
import type { SchemaStageState } from "../../../components/restaurant-schema/useSchemaStage";
import { LEGEND_SWATCH } from "./legendSwatches";
import LegendItem from "./LegendItem";

/**
 * Легендата под схемата + зуумът вдясно. „status" — Свободна / Резервирана /
 * Заета / час на следващата резервация; „picker" (избор на маса за нова
 * резервация) — Свободна / Побира гостите / Избрана / Заета в този час.
 * `nextReservationTime` — истинският час на следващата резервация в мострата
 * на чипа („Маркиране" → Схема; null там — няма предстояща, редът го няма);
 * без prop-а (Резервации) — примерът „20:00".
 */
const FloorLegend = ({
  mode,
  stage,
  isNarrow,
  nextReservationTime,
}: {
  mode: "status" | "picker";
  stage: SchemaStageState;
  isNarrow: boolean;
  nextReservationTime?: string | null;
}) => {
  const { t } = useTranslation();
  const items =
    mode === "status"
      ? (["free", "reserved", "occupied"] as const)
      : (["free", "fits", "selected", "blocked"] as const);

  return (
    <div
      className={`flex shrink-0 items-center justify-between gap-3 border-t border-shade-2 bg-surface ${
        isNarrow ? "px-3.5 py-2.5" : "px-[18px] py-3"
      }`}
    >
      <div className="flex min-w-0 flex-wrap items-center gap-x-5 gap-y-2">
        {items.map((item) => (
          <LegendItem key={item} swatch={<span className={LEGEND_SWATCH[item]} />}>
            {t(`reservations.legend.${item}`)}
          </LegendItem>
        ))}
        {mode === "status" && nextReservationTime !== null && (
          <LegendItem
            swatch={
              <span className="rounded-full border border-schema-next-edge bg-surface px-1.5 py-px text-[10.5px] font-bold tabular-nums text-schema-reserved-ink">
                {nextReservationTime ?? "20:00"}
              </span>
            }
          >
            {t("reservations.legend.nextReservation")}
          </LegendItem>
        )}
      </div>
      {!isNarrow && <ZoomControls placement="inline" {...stage.zoomControls} />}
    </div>
  );
};

export default FloorLegend;
